import React from 'react'
import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import { usePopUp } from 'app/hooks/AdminSettings/popUp'
import { Modal } from 'antd'
import { View } from 'styles/reactnative'
const PopUpDelete = ({ data }) => {
	const [modal, contextHolder] = Modal.useModal()
	const { deletePopUp } = usePopUp()

	const confirm = () => {
		modal.confirm({
			title: 'Confirm',
			content: 'Are you Sure You Want to Action this Item?',
			okText: 'Yes',
			cancelText: 'Cancel',
			onOk: async () => {
				await deletePopUp(data.id)
			},
		})
	}
	return (
		<View>
			<CButton
				title={'삭제'}
				onClick={confirm}
				style={{
					paddingBlock: 4,
					paddingInline: 10,
					background: COLORS.lightRed,
					color: COLORS.white,
					whiteSpace: 'nowrap',
				}}
			/>
			{contextHolder}
		</View>
	)
}

export default PopUpDelete
